export default __webpack_public_path__ + "static/media/training.e8eee0e4.jpg";